"use strict";
/// <reference path="irep.js" />
/// <reference path="third-party/bundled/knockout.js" />

IREP.auction = (function () {
    var msgPassed = '<p class="header">CONGRATULATIONS!</p><p>You’ve earned 100 points. Come back tomorrow for a chance to win more.</p>';
    var msgFailed = '<p class="header">SORRY.</p><p>That was incorrect. Try back tomorrow for a fresh chance to win.</p>';

    var init = function (options) {
        if (options.page == 'landing') {
            GetAuction();
            SumbitAnswer();
            HasTakenQuiz(options.activityCode);
            ShowQuestion();
                        
        }

        if (options.page == 'main') {
            GetAuction(options.verified);
        }

        if (options.page == 'pastitems') {
            GetPastItems();
        }
    }

    function ShowQuestion() {
        $('#ansQuestionBtn').click(function () {
            $('#questionInitial').css('display', 'none');
            $('#questionResponse').hide(function () { $('#questionOfTheDay').show(); });
        });
    }

    function GetPointsTotal() {
        IREP.callApi("/auction/getpoints", "GET", {
            ExchangeId: 2
        })
                    .done(function (data) {
                        //ko.applyBindings(new AuctionViewModel(data));
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        console.log("Failed to retrieve question:" + errorThrown);
                    });
    }

    function SumbitAnswer() {
        $(document).on('click', '.answer', function (e) {
            IREP.callApi("/quiz/questionresult", "POST", { AnswerCode: e.target.id })
                .done(function (data) {
                    if (data.hasPassed == 1) {
                        //GetQuiz(questionContent);
                        $('#questionTaken').append(msgPassed);
                        GetPointsTotal();

                    } else {
                        $('#questionTaken').append(msgFailed);
                    }
                    $('#questionOfTheDay').fadeOut(1000, function () { $('#questionResponse').fadeIn(); });
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log("Failed to submit answer:" + errorThrown);
                });
        });
    }

    function HasTakenQuiz(activityCode) {
        var qid = -2;
        IREP.callApi("/quiz/hasansweredquestion", "GET", { ActivityCode: activityCode })
                .done(function (data) {
                    var questionContent = {
                        ActivityCode: activityCode,
                        CultureCode: 'en-US',
                        QuestionId: data.questionId
                    };
                    if (data.questionId > 0) {
                        $('#questionInitial').css('display', 'block');
                        GetQuiz(questionContent);
                    } else {
                        if (data.questionId == -1) {
                            $('#questionTaken').append(msgPassed);
                            $('#questionInitial').hide(function () { $('#questionResponse').show(); })
                            //$('#questionResponse').css('display', 'block');
                        }
                        if (data.questionId == -2) {
                            $('#questionTaken').append(msgFailed);
                            $('#questionInitial').hide(function () { $('#questionResponse').show(); })
                        }
                    }

                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log("Failed to retrieve question status:" + errorThrown);
                });
        return qid;
    }

    function GetQuiz(content) {
        IREP.callApi("/quiz/getquestioncontent", "GET", {
            ActivityCode: content.ActivityCode,
            CultureCode: content.CultureCode,
            QuestionId: content.QuestionId
        })
                .done(function (data) {
                    PopulateQuestion(data)
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log("Failed to retrieve question:" + errorThrown);
                });
    }

    function PopulateQuestion(quizContent) {
        var question = quizContent.quiz.questions[0];
        $(document).ready(function () {
            $('#questionDMRAuction').append('<div id="questionText">' + question.questionText + '</div>');
            $.each(question.answers, function (key, value) {
                $('#answersDMRAuction').append('<div id="' + value.answerCode + '" class="answer">' + value.answerText + '</div>');
            });
        });
    }


    ////Auction Page Functionality

    function GetAuction(verified) {
        IREP.callApi("/auction/getauction", "GET", {
            AuctionId: 2
        })
                .done(function (data) {
                    var vm = new AuctionViewModel(data.auction, verified);
                    ko.applyBindings(vm);
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log("Failed to retrieve question:" + errorThrown);
                });
    }

    function AuctionViewModel(auction, verified) {
        var self = this;
        self.totalPoints = ko.observable(auction.points.totalPoints);
        self.pointsBid = ko.observable(auction.points.pointsBid);
        self.availablePoints = ko.observable(auction.points.availablePoints);
        self.activeBids = ko.observable(auction.points.activeBids);
        self.items = ko.observableArray(ko.utils.arrayMap(auction.items, function (item) { return new Item(item, self, verified); }));
        self.selectedItem = ko.observable();
    }

    function Item(item, auction, verified) {
        var self = this;
        self.id = ko.observable(item.id);
        self.uid = ko.observable(item.uid);
        self.startingBid = ko.observable(item.startingBid);
        self.currentBid = ko.observable(item.currentBid);
        self.bidIncrement = ko.observable(item.bidIncrement);
        self.expirationDate = ko.observable(moment(item.expirationDate).format("MMMM Do YYYY"));
        self.name = ko.observable(item.name);
        self.description = ko.observable(item.description);
        self.imageUrl = ko.observable(item.imageUrl);
        self.status = ko.observable(item.status);
        self.hasBid = ko.observable(item.hasBid);
        self.verified = ko.observable(verified);
        self.bidStatusText = ko.observable('');
        self.bidStatusImgVisible = ko.observable(false);
        self.showDisclaimer = ko.observable(item.showDisclaimer);
        self.bidStatusImg = ko.computed(
            function () {
                if (self.status() == 1) {
                    self.bidStatusImgVisible(true);
                    return 'https://retailedge.intel.com/Content/DMR/Auction/Items/winningBid.jpg';
                } else if (self.status() == 2) {
                    self.bidStatusImgVisible(true);
                    return 'https://retailedge.intel.com/Content/DMR/Auction/Items/losingBid.jpg';
                }
            });
        self.bidCount = ko.observable(1);
        self.bidAmount = ko.computed(function () {
            if (!self.hasBid()) {
                return ((self.bidCount() - 1) * self.bidIncrement()) + self.currentBid();
            } else {
                var value = (self.bidCount() * self.bidIncrement()) + self.currentBid();
                return value;
            }
        });
        self.pointColor = ko.computed(function () {
            if (self.status() == 1) {
                return '#a6ce39';
            } else if (self.status() == 2) {
                return '#fc4c02';
            } else {
                return '#0071C5';
            }
        });
        var isLive = checkLiveDate();
        self.live = ko.observable(false);

        self.available = ko.observable(true);
        self.auction = auction
        self.bidFont = ko.computed(function () {
            if ((self.status() == 1) && (self.auction.availablePoints() < self.bidIncrement())) {
                return 'italic';
            }
            if ((self.status() == 2 || self.status() == 0) && (self.auction.availablePoints() <= (self.currentBid() + self.bidIncrement()))) {
                return 'italic';
            }
        });
    }

    function checkLiveDate() {
        var currentDate = Date.now();
        var liveDate = Date.UTC(2015, 6, 6, 22, 0, 0, 0);

        if (currentDate >= liveDate) {
            return true;
        }
        else {
            return false;
        }
    }

    //function closeAuction() {
    //    var q = new Date();        
    //    var closingDate = new Date('2015-09-07 17:00:00');

    //    if (q >= closingDate)
    //    {
    //        return false;
    //    }
    //    else
    //    {
    //        return true;
    //    }
    //}

    Item.prototype.itemClicked = function (d) {
        var test = this.currentBid() + this.bidIncrement();
        this.auction.selectedItem(d);
        this.bidCount(1);
        var heightPercentage = ($(document).scrollTop() - $('#headerAuction').height() - 100);
        open_box(heightPercentage);
    }

    Item.prototype.submitBid = function (d) {
        var self = this;

        if (self.showDisclaimer() == 1) {
            self.bidStatusText('You must complete all four <a href="landing#take6">Workplace Transformation</a> courses.');
        }

        if (((self.status() == 2 || self.status() == 0) && self.auction.availablePoints() >= self.bidAmount() && self.showDisclaimer() == 0) ||
            (self.status() == 1 && self.auction.availablePoints() >= self.bidIncrement() && self.showDisclaimer() == 0)) {
            IREP.callApi("/auction/submitbid", "POST", {
                ExchangeId: 2,
                AuctionUid: self.uid(),
                Bid: self.bidAmount()
            })
            .done(function (data) {
                if (data.updates.item != null) {
                    var item = data.updates.item;
                    var points = data.updates.points;

                    if (data.updates.bidStatus == 2) {
                        self.bidStatusText('You may only bid to win one of each item.');
                    }

                    if (data.updates.bidStatus == 1) {
                        self.currentBid(item.currentBid);
                        self.auction.activeBids(points.activeBids);
                        self.auction.availablePoints(points.availablePoints);
                        self.auction.pointsBid(points.pointsBid);
                        self.auction.totalPoints(points.totalPoints);
                        self.status(item.status);
                        self.hasBid(item.hasBid);
                        self.bidCount(1);

                        self.bidStatusText('Your bid was successful!');
                    }
                    if (data.updates.bidStatus == 0) {
                        self.bidStatusText('You do not have enough points!');
                    }
                } else {
                    self.live(false);
                    self.available(false);
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.log("Failed to retrieve question:" + errorThrown);
            });
        }
    }

    Item.prototype.bidUp = function () {
        if ((this.status() == 2 || this.status() == 0) && (this.bidAmount() + this.bidIncrement()) <= this.auction.availablePoints()) {
            var count = this.bidCount();
            this.bidCount(++count);
        }
        if (this.status() == 1 && (this.bidAmount() - this.currentBid() + this.bidIncrement()) < this.auction.availablePoints()) {
            var count = this.bidCount();
            this.bidCount(++count);
        }
    }

    Item.prototype.bidDown = function () {
        if (this.bidAmount() > (this.currentBid() + this.bidIncrement())) {
            var count = this.bidCount();
            this.bidCount(--count);
        }
    }

    Item.prototype.close = function () {
        close_box();
    }

    AuctionViewModel.prototype.close = function () {
        close_box();
    }

    $(document).on('click', '.close', function (e) {
        close_box();
    });

    function open_box(height) {
        $('.backdrop, .box').animate({
            'opacity': '.50'
        }, 300, 'linear');
        $('.box').animate({
            'opacity': '1.00'
        }, 300, 'linear');
        $('.backdrop, .box').css('display', 'block');
        $('#auctionItems').css('padding-bottom', height + 'px');
    }

    function close_box() {
        $('.backdrop, .box').animate({
            'opacity': '0'
        }, 300, 'linear', function () {
            $('.backdrop, .box').css('display', 'none');
        });
    }

    function GetPastItems() {
        IREP.callApi("/auction/getpastitems", "GET", {
            ExchangeId: 2
        })
                .done(function (data) {
                    var vm = new vmPastItems(data.pastItems);
                    ko.applyBindings(vm, document.getElementById('pastItems'));
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    console.log("Failed to retrieve Past Items:" + errorThrown);
                });
    }

    function vmPastItems(items) {
        var self = this;
        self.pastItems = ko.observableArray(ko.utils.arrayMap(items, function (item) { return new PastItem(item); }));
    }

    function PastItem(item) {
        var self = this;
        self.uid = ko.observable(item.uid);
        self.startingBid = ko.observable(item.startingBid);
        self.currentBid = ko.observable(item.currentBid + ' PTS');
        self.participantBid = ko.observable(item.participantBid + ' PTS');
        //self.expirationDate = ko.observable(moment(item.expirationDate).format("MMMM Do YYYY"));
        self.name = ko.observable(item.name);
        self.imageUrl = ko.observable(item.imageUrl);
        self.status = ko.observable(item.status);
        self.hasBid = ko.observable(item.hasBid);
        self.textStatus = ko.observable();
        self.bidStatusImg = ko.computed(
            function () {
                if (self.status() == 3) {
                    self.textStatus('YOU WON THIS ITEM');
                    return 'https://retailedge.intel.com/Content/DMR/Auction/Items/winningBid.jpg';
                } else if (self.status() == 2) {
                    self.textStatus('YOU WERE OUT BID');
                    return 'https://retailedge.intel.com/Content/DMR/Auction/Items/losingBid.jpg';
                }
            });
        self.pointColor = ko.computed(function () {
            if (self.status() == 3) {
                return '#9bc42c';
            } else if (self.status() == 2) {
                return '#FDB813';
            } else {
                return '#0071C5';
            }
        });
    }

    return {
        init: init
    };
})();